<template>
  <ResponsiveLayout>
    <div class="kds-main-wrapper">
      <p class="kds-typography-display-small">
        {{ $t('password_reset__title') }}
      </p>
      <BaseBanner
        v-if="error"
        :description="$t('password_reset__error_description')"
        :title="$t('password_reset__error_title')"
        variant="warning"
      />
      <BaseBanner
        v-else-if="success"
        :description="$t('password_reset__success_description')"
        :title="$t('password_reset__success_title')"
        variant="success"
      />
      <form
        v-else
        class="kds-content-block"
      >
        <p class="kds-typography-paragraph-large">
          {{ $t('password_reset__description') }}
        </p>
        <PasswordField
          autocomplete="new-password"
          label="generic_field_new_password"
          show-password-requirements
          v-bind="fieldAttrs.password"
        />
        <BaseButton
          :text="$t('password_reset__cta')"
          v-bind="submitAttrs"
        />
      </form>
    </div>
  </ResponsiveLayout>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { ref } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import PasswordField from '@shared/components/form/PasswordField.vue'
import BaseBanner from '@shared/components/BaseBanner.vue'
import useForm from '@shared/composables/useForm.js'
import BaseButton from '@shared/components/BaseButton.vue'
import * as api from '@shared/api-endpoints/index.js'
import env from '@shared/env.js'

const route = useRoute()

const token = ref(route.query.reset_password_token)
// only allow the api base url to be set in stage/dev
const apiBaseUrl = ref(env.isProd ? null : route.query.api_base_url)
const success = ref(false)
const error = ref(!token.value)

const { fieldAttrs, submitAttrs } = useForm(
  ref({ password: '' }),
  ref({ password: { validations: ['required', 'password'] } }),
  {
    onSubmit: async (form) =>
      api.resetPassword(token.value, form.value.password, apiBaseUrl.value),
    onSuccess: () => (success.value = true),
    onError: () => (error.value = true),
  },
)
</script>

<style lang="scss" scoped></style>
